export const GET_LOCAL_STORES = "GET_LOCAL_STORES"
export const GET_LOCAL_STORES_SUCCESS = "GET_LOCAL_STORES_SUCCESS"
export const GET_LOCAL_STORES_FAIL = "GET_LOCAL_STORES_FAIL"
export const DELETE_LOCAL_STORE = "DELETE_LOCAL_STORE"
export const CLEAR_LOCAL_STORES = "CLEAR_LOCAL_STORES"
export const SET_LOCAL_STORES_QUERY_OBJECT = "SET_LOCAL_STORES_QUERY_OBJECT"